import React from 'react';

const Privacy = () => {
  return (
    <div style={{ height: '100vh' }}>
      <iframe
        src="/docs/Privacy Policy.pdf"
        title="Terms of Service"
        width="100%"
        height="100%"
        style={{ border: 'none' }}
      ></iframe>
    </div>
  );
};

export default Privacy;
